import React from "react"
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'
import clearProps from '../../utils/clearProps'

export default class Breadcrumb extends React.Component {
  constructor(props) {
    super(props)
    this.config = {
      types: [
        {
          title: 'default',
          isDefault: true,
        },
      ],
      modifiers : [],
      states : []
    }
  }

  renderPages(dataBreadcrumb) { 
    return dataBreadcrumb.map((item,index) => <li key={index} className="mdn-Breadcrumb-list-item">
      <a className="mdn-Breadcrumb-link" target={item.target} href={item.url} {...item.props}>{item.page}</a>
      <span className="mdn-Breadcrumb-icon mdn-Icon-direita mdn-Icon--sm"></span>
    </li>)
  }
  
  render() {
    const { dataBreadcrumb, data, ...rest } = this.props
    const props = clearProps(this.props)
    return <nav {...rest} className={resolveProps(this.props, this.config, 'Breadcrumb')}>
      <ul className="mdn-Breadcrumb-list">
        {this.renderPages(data || dataBreadcrumb)}
      </ul>
    </nav>
  }
}

Breadcrumb.propTypes = {
  dataBreadcrumb : PropTypes.array
}